import Cookies from 'js-cookie';

import { Cookie } from 'constants/cookie';
import { FakeLink } from 'components/fake-link/FakeLink';
import { sessionsClient } from 'services/connectivity/session/client';
import { getAccessToken } from 'utils/account';

import * as styles from './styles';

interface ISwitchAccountsProps {
  label: string;
  email?: string;
}

export const SwitchAccounts = ({ label, email }: ISwitchAccountsProps) => {
  const handleLogout = () => {
    const token = getAccessToken();
    if (token) {
      sessionsClient.removeCurrent(token);
    }
    Cookies.remove('product');
    Cookies.remove('access_token');
    Cookies.remove(Cookie.VerificationCodeSend);
  };

  return (
    <div css={styles.switchButton}>
      <FakeLink
        onClick={handleLogout}
        href={email ? `/?email=${encodeURIComponent(email)}` : '/'}
        dataTestid="switch-accounts-button"
      >
        {label || 'Switch accounts'}
      </FakeLink>
    </div>
  );
};
